import { Outlet } from "react-router";

import Box from "@mui/material/Box";
import CssBaseline from "@mui/material/CssBaseline";
// import Toolbar from "@mui/material/Toolbar";

import { AlertBar } from "../AlertBar";
import SideMenu from "../SideMenu";
import TopMenu from "../TopMenu";

function Layout() {
	return (
		<Box sx={{ display: "flex", maxWidth: "100vw" }}>
			<CssBaseline />
			<SideMenu />
			<Box
				sx={{
					flexGrow: 1,
					bgcolor: "background.default",
					maxWidth: "calc(100% - 52px)",
					width: "100vw",
				}}
			>
				<TopMenu />
				<AlertBar />
				<Box
					component="main"
					sx={{
						flexGrow: 1,
						bgcolor: "background.default",
						maxWidth: "100%",
						width: "100vw",
					}}
				>
					<Box sx={{ px: 4, py: 3, width: "100%", boxSizing: "border-box" }}>
						<Outlet />
					</Box>
				</Box>
			</Box>
		</Box>
	);
}
export default Layout;
